import RecentlyVisitedSTEmptyState from './RecentlyVisitedSTEmptyState';

export default RecentlyVisitedSTEmptyState;
